import React, { Component } from 'react'

export default class CenteredContainer extends Component {
  render () {
    return (
      <div style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        // flex: 0,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white'
      }}>
        <div>
          {this.props.children}
        </div>
      </div>
    )
  }
}
